import { ref } from "vue";

const configProduction = true;

const apiUrl = (configProduction ? 'https://event.api.v1.onlinefundraising.dk' : 'https://development.event.api.onlinefundraising.dk');
const callcenterUrl = (configProduction ? 'https://knaekcancer.callcenter.onlinefundraising.dk' : 'https://testevent.callcenter.onlinefundraising.dk'); // https://callcenter.event.onlinefundraising.dk

const eventId = ref(localStorage.getItem('eventId'));

const validUntilTs = ref(localStorage.getItem('validUntilTs'));

const event = ref();

const correctionTypes = ref({
    EVENT_PAYMENT: 'Event payment',
    BUSINESS_PAYMENT: 'Business payment',
    CARD: 'Betalingskort',
    MOBILE_PAY_ONLINE: 'MobilePay Online',
    MOBILE_PAY_EXTERNAL: 'MobilePay External',
    BETALINGSSERVICE_SINGLE: 'Betalingsservice',
    SMS: 'SMS Donation',
    SMS_LOTTERY: 'SMS Lodtrækning',
    FUNDRAISING: 'Egenindsamling',
    OTHER: 'Andet',
})


const searchOptions = ref({
    searchField:
        [
            { slug: 'COMPANY_NAME', name: 'Søg på firmanavn' },
            { slug: 'DISPLAY_NAME', name: 'Søg på visningsnavn' },
            { slug: 'BUSINESS_CODE', name: 'Søg på CVR-nr.' },
            { slug: 'MSISDN', name: 'Søg på tlf.nr.' },
            { slug: 'PERSONAL_NAME', name: 'Søg på kontaktpersons navn' },
            { slug: 'EMAIL', name: 'Søg på email' }
        ]
})

const user = ref({
    authToken: null,
    userGuid: null,
    name: null
});

export { apiUrl, callcenterUrl, eventId, validUntilTs, event, user, searchOptions, configProduction, correctionTypes }